import { createAction, props } from '@ngrx/store';

export const navSetActiveStep = createAction('[Navigation] set active step', props<{ activeStep: any }>());
export const navActivateNextStep = createAction('[Navigation] activate next step', props<{ finishedStep: any }>());
export const navUpdate = createAction('[Navigation] update', props<{ payload: any }>());
export const navToB2B = createAction('[Navigation] navigate to B2B');
export const navOpenManualInstall = createAction('[Navigation] open manual install');
export const navBack = createAction('[Navigation] back to integrate main screen');
export const navFinishInstallation = createAction('[Navigation] finish installation', props<{ finishedStep: any }>());
